export const DEFAULT_SESSION_MIN_PROVIDERS = 1;
export const DEFAULT_SESSION_MAX_PROVIDERS = 5;
//# sourceMappingURL=blocks.js.map